import { withAsyncBoundary } from '@toss/async-boundary';
import { useTranslation } from 'next-i18next';
import { usePublicLibraryList } from '@/module/public/hooks/usePublicLibraryList';
export const TotalLibraryCount = withAsyncBoundary((props: {
  className?: string;
}) => {
  const {
    data
  } = usePublicLibraryList();
  const {
    t
  } = useTranslation(['common']);
  const firstPage = data?.pages[0];
  const count = firstPage?.totalCount;
  if (count == null) return null;
  return <span className={props.className}>
        {t('common:formatNumber.count', {
      n: (count ?? 0).toLocaleString()
    })}
      </span>;
}, {
  pendingFallback: null,
  rejectedFallback: () => 0
});